/**
 * WD-8 — Send-test confirm.
 * US-A08 AC4: a test reaches only the administrator's own account.
 */
import { useAdminTranslate } from '@/providers/i18n-provider'
import { ConfirmDialog } from './ConfirmDialog'

export interface SendTestConfirmDialogProps {
  open: boolean
  adminEmail: string
  onConfirm: () => Promise<void> | void
  onCancel: () => void
}

export const SendTestConfirmDialog = ({
  open,
  adminEmail,
  onConfirm,
  onCancel,
}: SendTestConfirmDialogProps) => {
  const translate = useAdminTranslate()

  return (
    <ConfirmDialog
      open={open}
      title={translate('admin.dialogs.sendTest.title')}
      description={translate('admin.dialogs.sendTest.description', { email: adminEmail })}
      confirmLabel={translate('admin.dialogs.sendTest.confirm')}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}
